import { render, staticRenderFns } from "./PartnerDispatchForm.vue?vue&type=template&id=5b4f086c&"
import script from "./PartnerDispatchForm.vue?vue&type=script&lang=js&"
export * from "./PartnerDispatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports